import './zekos/style';
import FormStructure from './zekos/form_structure';

export default FormStructure;